export default {
  title: "Вы имеете доступ <b>только на просмотр</b>.",
  description:
    "Для того чтобы иметь возможность редактировать информацию обратитесь к своему организатору."
};
